module.exports = "https://coursera_assets.s3.amazonaws.com/images/0ac81ea004b21acd490cc1208f703ef0.png";